<template>
  <div>
    <vs-input
      v-on:keyup="checkAccount"
      data-vv-validate-on="blur"
      v-validate="'required'"
      name="username"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      label-placeholder="Username"
      v-model="username"
      class="w-full mt-6" />
     <span class="text-danger text-sm">{{ errors.first('username') }}</span>
   
    <vs-input
      v-if="showPassword"
      data-vv-validate-on="blur"
      v-validate="'required|min:4|max:10'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      label-placeholder="Password"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <vs-alert :active.sync="showNoAccount"  color="danger" class="text-center mt-2 ">
      <span>No account found for {{ this.username }}.</span>
    </vs-alert>

    <div class="flex flex-wrap justify-right my-5 mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  data () {
    return {
      username: '',
      password: '',
      showPassword:false,
      showNoAccount:false,
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.username.length>0
    },
  },
  methods: {
    checkAccount(){
      this.showNoAccount = false          
      this.showPassword = false
      let un =  this.username


     if(un.length>3){      
       // if(un.includes('@') && un.split('@')[1].includes('.')){      
       const payload = {        
        username: un        
      }     
      console.log(JSON.stringify(payload))        
      this.$store.dispatch('auth/loginUiJWT', payload)
        .then(r => {
          debugger
          const t = JSON.parse(r.data.data)
          var _check=0
          if(t.Exists==0){
           this.showNoAccount = true
            _check =1
          }
          if(_check==0 && t.Exists==1 && t.PwReset ==0){
           this.showPassword = true
            _check =1
          }
          if(_check==0 && t.Exists==1 && t.PwReset ==1){
            router.push(`/reset/${ t.Guid}`)
            _check =1
          }
          this.$vs.loading.close()
      })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {
    //  if (!this.checkLogin()) return
      
      // Loading
      this.$vs.loading()

      const payload = {        
        username: this.username,   
        password: this.password        
      }     
           
      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => {           
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    loginUiJWT () {
      this.$vs.loading()
      const payload = {        
        username: this.username      
      }                
      this.$store.dispatch('auth/loginUiJWT', payload)
        .then(() => {       
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}

</script>
